export const GC_SUPPORT_EMAIL = "help@gocardless.com";
export const GC_VERIFICATION_EMAIL = "verification@gocardless.com";

export const ONE_DAY_IN_MS = 86400000;
